import React from 'react';

import { rootConfig } from '../../../config/config';
import MainListLoader from '../Loaders/MainListLoader';
import {
  AuthorAndTime,
  Title,
  ListElement,
  Card,
  CardData,
  CardHolder,
  StyledLine,
  StyledLineInside,
  FlexContainer,
  Rating
} from '../StyledComponents';

const List_Show_More = props => {
  // console.log('props: ', props);
  const { showMore, handleLoadMore, contentData, clicked, title } = props;

  let cards = null;
  if (contentData) {
    cards = contentData.map(content => {
      return (
        <Card onClick={() => clicked(content.postSlug)} key={content.id}>
          <div className="ImageDiv relative">
            {content.rating ? (
              <FlexContainer className="Rating">
                <Rating
                  className="absolute right-0"
                  width="50px"
                  height="50px"
                  padding="12px"
                  background="#4db2ec"
                >
                  <Title
                    className="Rating-Text"
                    fontFamily="Montserrat"
                    fontWeight="bold"
                    fontSize="1.5625rem"
                    color="#fff"
                  >
                    {content.rating}
                  </Title>
                </Rating>
              </FlexContainer>
            ) : null}
            <div
              style={{
                width: '225px',
                height: '112.5px',
                // background: `url(${rootConfig.imagesRoot}/${
                //   content.featuredImage.file
                // })`,
                background: `${
                  content.featuredImage
                    ? `url(${rootConfig.imagesRoot}/${
                        content.featuredImage.file
                      })`
                    : 'black'
                }`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            {/* <img
              src={
                content.featuredImage
                  ? `${rootConfig.imagesRoot}/${content.featuredImage.file}`
                  : null
              }
              alt={content.postSlug}
              className="w-100 mw7 w5-ns"
            /> */}
          </div>
          <CardData>
            <Title
              fontFamily="Nunito"
              fontSize="1.3rem"
              fontWeight="bold"
              lineHeight="1.25"
            >
              {content.postTitle}
            </Title>
            <AuthorAndTime
              color="#8e8e8e"
              fontFamily="Montserrat"
              fontSize="0.75rem"
              fontWeight="normal"
              // padding="0.5rem 0.5rem 0.5rem 0"
            >
              <div>{content.postAuthor.authorName}</div>
              <div>{content.postDate}</div>
            </AuthorAndTime>
          </CardData>
        </Card>
      );
    });
  }

  return (
    <ListElement className="left-container" padding="2.25rem 1.2rem">
      <Title
        className="ttc"
        fontFamily="Montserrat"
        fontSize="2.25rem"
        fontWeight="bold"
      >
        {title}
      </Title>
      <StyledLine>
        <StyledLineInside />
      </StyledLine>

      {/* Load Recent News Medium Like spinner instead of null in below line */}
      {cards !== null ? <CardHolder>{cards}</CardHolder> : <MainListLoader />}
      {showMore === true ? (
        <FlexContainer alignitems="center" justifycontent="center">
          <button
            className="show-more mt2"
            style={{ background: '#4db2ec', height: '44px', width: '249px' }}
            onClick={handleLoadMore}
          >
            <Title
              color="#fff"
              fontFamily="Nunito"
              fontSize="0.875rem"
              fontWeight="bold"
            >
              SHOW MORE
            </Title>
          </button>
        </FlexContainer>
      ) : null}
    </ListElement>
  );
};

export default List_Show_More;
